<template>
    <div>
        <modal-x :show="showLabelCats" :content-style="{ maxWidth: '800px' }" @onclose="showLabelCats = false">
            <category-tree v-if="showLabelCats" :selected="selectedCatIds" :cat-node="lableCatNode"
                v-on:catSelected="lableCatSelectUpdated" :viewMode="{}" :expand-all="true"></category-tree>
        </modal-x>
        <modal-x :show="showTags" :content-style="{ maxWidth: '800px' }" @onclose="showTags = false">
            <category-tree v-if="showTags" :selected="selectedTagIds" :cat-node="tagNode"
                v-on:catSelected="tagSelectUpdated" :viewMode="{}" :expand-all="true"></category-tree>
        </modal-x>
        <div>
            <div class="col-xs-12" style="padding:4px;border:1px solid #ddd;background: rgba(1,1,1,0.2);">
                <div class="col-xs-12 col-md-8">
                    <div class="col-xs-12"  style="text-align:center;">
                        <span class="btn btn-default" @click="editTags">Select Tags</span>
                        <span class="btn btn-default" @click="editLabels">Select Labels</span>
                    </div>
                    <div class="col-xs-12"  style="text-align:center;" v-if="lableCatNode!==null">
                        <div class="col-xs-6" style="font-weight:bolder;">Selected Labels</div>
                        <div class="col-xs-6" style="font-weight:bolder;">Data Type</div>
                        <template v-for="label in retObj.labelCats">
                            <div class="col-xs-6">{{ label }}: {{ findNameByCatId(label, lableCatNode) }} </div>
                            <div class="col-xs-6">
                               <!-- <input type="text" class="form-control" v-model="retObj.labelCatValType[label]" /> -->
                                 <select class="form-control" v-model="retObj.labelCatValType[label]">
                                        <option value="">Please Select</option>
                                        <option value="string">String</option>
                                        <option value="number">Number</option>
                                        <option value="date">Date</option>
                                        <option value="boolean">Boolean</option>
                                        <!-- <option value="object">Object</option>
                                        <option value="array">Array</option> -->
                                  </select>
                            </div>
                        </template>
                    </div>
                    <div class="col-xs-12" style="text-align: center;" v-if="tagNode!==null">
                        <div class="col-xs-12" style="font-weight:bolder;text-align: center;">Selected Tags</div>
                        <template v-for="label in retObj.tags">
                            <div class="col-xs-12">{{ label }}: {{ findNameByCatId(label, tagNode) }} </div>                            
                        </template>
                    </div>
                </div>
                <div class="col-xs-12 col-md-4">
                    {{ retObj }}
                </div>
            </div>
        </div>
        <div><input type="button" class="btn btn-default" @click="save" value="Done" /></div>
    </div>
</template>
<script>
import CategoryTree from '../components/CategoryTree.vue';
import imageList from './imageList.vue';
import modalX from '../components/base/ModalX1.vue';
import apis from '../api/extApi.js';

export default {
    components: {
        CategoryTree: CategoryTree,
        imageList: imageList,
        modalX: modalX
    },
    props: ["shopUserId", "initData"],
    computed: {

    },
    data: function () {
        return {
            apiClient: apis.api,
            catCodes: apis.api.settings.catCodes,
            imgHandler: null,
            isSelectingImage: false,
            selectedImgs: [],
            retObj: this.initData === null ? { labelCats: [], tags: [], labelCatValType:{} } : this.initData,
            selectedCatIds: { catIds: [], timestamp: 0 },
            selectedTagIds: { catIds: [], timestamp: 0 },
            showLabelCats: false,
            lableCatNode: null,
            showTags: false,
            tagNode: null
        };
    },
    methods: {
        findNameByCatId: function findNameByCatId(catId, data) {
            if (data.catId === catId) {
                return data.name;
            }
            if (data.childs && data.childs.length > 0) {
                for (let child of data.childs) {
                    const result = this.findNameByCatId(catId, child);
                    if (result) {
                        return result;
                    }
                }
            }
            return null;
        },
        save: function () {
            this.$emit("onsave", this.retObj);
        },
        editTags: function () {
            this.loadTagCats((that)=>{
                that.showTags = true;
            });
        },
        tagSelectUpdated(ret) {
            console.log("cat update", ret);
            var catIds = this.retObj.tags;
            if (!catIds) {
                catIds = [];
                this.retObj.tags = catIds;
            }
            var index = catIds.indexOf(ret.child.catId);
            if (index >= 0) {
                this.retObj.tags.splice(index, 1);
            } else {
                this.retObj.tags.push(ret.child.catId);
            }
            this.selectedTagIds.catIds = this.retObj.tags;
            this.selectedTagIds.timestamp = Date.now();
        },
        lableCatSelectUpdated(ret) {
            console.log("cat update", ret);
            var catIds = this.retObj.labelCats;
            if (!catIds) {
                catIds = [];
                this.retObj.labelCats = catIds;
            }
            var index = catIds.indexOf(ret.child.catId);
            if (index >= 0) {
                this.retObj.labelCats.splice(index, 1);
            } else {
                this.retObj.labelCats.push(ret.child.catId);
            }
            this.selectedCatIds.catIds = this.retObj.labelCats;
            this.selectedCatIds.timestamp = Date.now();
            this.$set(this.retObj, 'labelCats', this.retObj.labelCats);
        },
        editLabels: function () {
            this.loadLabelCats((that)=>{
                that.showLabelCats = true;
            });
        },
        loadLabelCats(onLoad){
            this.apiClient.getCategoryNodePrms(this.catCodes.label, this.shopUserId).done((ret) => {
                console.log('cat node', ret);
                this.lableCatNode = ret;
                if(onLoad) onLoad(this);
            });
        },
        loadTagCats(onLoad){
            this.apiClient.getCategoryNodePrms(this.catCodes.tag, this.shopUserId).done((ret) => {
                console.log('cat node', ret);
                this.tagNode = ret;
                if(onLoad) onLoad(this);
            });
        }
    },
    created: function () {

    },
    mounted: function () {
        console.log("jsonData userid", this.shopUserId);
        if (this.retObj.labelCats) {
            this.loadLabelCats();
            this.selectedCatIds.catIds = this.retObj.labelCats;
            this.selectedCatIds.timestamp = Date.now();
        }

        if(this.retObj.tags){
            this.loadTagCats();
        }

    },
    destroyed: function () {
    }
}
</script>